import { IModule } from 'redux-state/layout/types.js';
import { IModuleConfig } from 'redux-state/layout/types.modules.js';
import { ModulePath } from 'utilities/modulePath/modulePath.js';
import { ModuleLoad } from './module-load.js';

export type ModuleLoadCB = () => void;

/** Lazy load module */
export const ModuleArrLoad = ({
  modules = [],
  modulePath,
}: {
  modules: IModule<IModuleConfig, 'Raw'>['config'][] | undefined;
  modulePath: ModulePath;
}) => {
  return (
    <>
      {modules.map((config, i) => {
        // console.log(`${config.name}-${modulePath}`);
        return <ModuleLoad key={`${config.name}-${i}`} config={config} modulePath={modulePath} />;
      })}
    </>
  );
};
